import { ApolloClient, NormalizedCacheObject, gql } from '@apollo/client';
import {
  RefreshTokenInterceptorMutation,
  RefreshTokenInterceptorMutationVariables,
} from './__generated__/RefreshTokenInterceptorMutation';

class AuthApollo {
  constructor(private client: ApolloClient<NormalizedCacheObject>, private refresh_token: string) {}

  async get_new_token() {
    const { data } = await this.client.mutate<
      RefreshTokenInterceptorMutation,
      RefreshTokenInterceptorMutationVariables
    >({
      mutation: gql`
        mutation RefreshTokenInterceptorMutation($refresh_token: String!) {
          refreshToken(refresh_token: $refresh_token) {
            token
            refresh_token
            dsc_nome_usuario
          }
        }
      `,
      variables: {
        refresh_token: this.refresh_token,
      },
    });

    return data?.refreshToken;
  }
}

export { AuthApollo };
